import { Form, Modal } from "antd";
import React from "react";
import { CreateContragentDto } from "../../../api";
import { contragentsColumns } from "../form/columns";

interface ContragentFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateContragent: (values: CreateContragentDto) => void;
}

export const ContragentForm: React.FC<ContragentFormProps> = ({ visible, setVisible, onCreateContragent }) => {
  const [form] = Form.useForm<CreateContragentDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateContragent}>
        {contragentsColumns.map(({ title, dataIndex, rules, inputNode }, index1) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index1}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
